/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Occupied_UntilInputs */

const cs_form_occupied_until = /** @type {(inputs: Form_Occupied_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsazeno do`)
};

const en_form_occupied_until = /** @type {(inputs: Form_Occupied_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Occupied until`)
};

/**
* | output |
* | --- |
* | "Occupied until" |
*
* @param {Form_Occupied_UntilInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_occupied_until = /** @type {((inputs?: Form_Occupied_UntilInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Occupied_UntilInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_occupied_until(inputs)
	return cs_form_occupied_until(inputs)
});